import { MouseEvent, useCallback, useState } from 'react';

export const useEditSegmentNameModal = () => {
  const [editSegmentNameModalIsOpen, setEditSegmentNameModalIsOpen] = useState(false);
  const [position, setPosition] = useState([0, 0]);

  const handleOpenEditSegmentNameModal = useCallback((event: MouseEvent<HTMLButtonElement>) => {
    const { left, top } = event.currentTarget.getBoundingClientRect();
    setPosition([left, top]);
    setEditSegmentNameModalIsOpen(true);
  }, []);

  return {
    position,
    editSegmentNameModalIsOpen,
    setEditSegmentNameModalIsOpen,
    handleOpenEditSegmentNameModal,
  };
};
